import $ from "jquery";

// Handle drag events
$(".sb_gallery_visuals").on("dragStart.flickity", (event) => {
    $(event.currentTarget).addClass("s_is-dragging");
});

$(".sb_gallery_visuals").on("dragEnd.flickity", (event) => {
    $(event.currentTarget).removeClass("s_is-dragging");
});

/**
 * Open visuals overlay
 */
$("[data-gallery-open-visuals-overlay]").on("click tap", function (e) {
    e.preventDefault();

    $("body").addClass("s_is-open_visuals-overlay");

    let galleryID = $(this).attr("data-gallery-open-visuals-overlay");
    let openOnSLide = $(this).attr("data-open-slide");

    // add hash to full-screen image gallery
    window.location.hash = `#${galleryID}%${openOnSLide}`;
});
